var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "auto-height",
    { staticClass: "send-list-container", attrs: { margin: _vm.margin } },
    [
      _c("div", { staticClass: "row h-100" }, [
        _c(
          "div",
          { staticClass: "col d-flex flex-column h-100" },
          [
            _c(
              "el-collapse-transition",
              [
                _c("filter-labels", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasLabels,
                      expression: "hasLabels",
                    },
                  ],
                  staticClass: "mb-1",
                  attrs: { namespace: _vm.filterNamespace },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-collapse-transition", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isFilterVisible,
                      expression: "isFilterVisible",
                    },
                  ],
                },
                [
                  _c("filters-wrapper", {
                    attrs: { namespace: _vm.filterNamespace },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("input-debounced", {
                  staticClass: "search-bar mb-2",
                  attrs: {
                    value: _vm.filters.search,
                    clearable: "",
                    autofocus: "",
                    placeholder: "Search",
                  },
                  on: { input: _vm.updateSearchFilter },
                }),
                _vm._v(" "),
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "top",
                      trigger: "hover",
                      content: "Refresh list",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-purple align-self-start ml-1",
                        attrs: { slot: "reference" },
                        on: { click: _vm.refreshList },
                        slot: "reference",
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-sync",
                          class: { "fa-spin": _vm.isListRefreshingActive },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "top",
                      trigger: "hover",
                      content: "Toggle filter",
                      "open-delay": 500,
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-purple align-self-start ml-1",
                        attrs: { slot: "reference" },
                        on: { click: _vm.filterToggle },
                        slot: "reference",
                      },
                      [_c("i", { staticClass: "fas fa-filter" })]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("list", {
              ref: "list",
              staticClass: "list",
              attrs: { url: _vm.url },
              on: {
                select: _vm.onSelect,
                "quick-message": _vm.onSendQuickMessage,
                "email-message": (e) => _vm.$emit("email-message", e),
                edit: _vm.onEdit,
                delete: _vm.onDelete,
                "refresh-start": _vm.onListRefreshStarted,
                "refresh-finish": _vm.onListRefreshFinished,
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }